module.exports = __webpack_public_path__ + "static/media/home-gallery-image3.43ad9ef3.png";